module.exports = __webpack_public_path__ + "img/甜点蛋糕店图片生成.b5c98746.jpeg";